
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as paykqhEfZ32a9DKetLFK9xllLq0lY5oZfPWxtxT_bJSIr4Meta } from "/src/app/pages/pay.vue?macro=true";
import { default as indexlOQXz4qHz1_tjzzS__aw5L3qkduUse1pUPQ2t0gdaSoMeta } from "/src/app/pages/index.vue?macro=true";
import { default as surveylmraSCxWv2Tsv0R8Pree7zvzteitRJE3_Npx1l_ZiNAMeta } from "/src/app/pages/survey.vue?macro=true";
import { default as privacyJG5nMU8cE6HguauHzTvZQlDaAa5zcVKWVTxBPnfHDY0Meta } from "/src/app/pages/privacy.vue?macro=true";
import { default as manifestL2Vr54JuaGdj99AbKChIdTuZeVJUCVBlLXGoazqDIwcMeta } from "/src/app/pages/manifest.vue?macro=true";
import { default as documentsPxWFI2Q4c_pp8BIMJSjcKTDcHadQRqlw5EULtjVOKDYMeta } from "/src/app/pages/documents.vue?macro=true";
import { default as documents_lunavl7T_AhvEOzVk_wX_5KaWLsJG9SXJb_TMyYlSSY0tMQMeta } from "/src/app/pages/documents_luna.vue?macro=true";
export default [
  {
    name: "pay",
    path: "/pay",
    component: () => import("/src/app/pages/pay.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/src/app/pages/index.vue")
  },
  {
    name: "survey",
    path: "/survey",
    component: () => import("/src/app/pages/survey.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/src/app/pages/privacy.vue")
  },
  {
    name: "manifest",
    path: "/manifest",
    component: () => import("/src/app/pages/manifest.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/src/app/pages/documents.vue")
  },
  {
    name: "documents_luna",
    path: "/documents_luna",
    component: () => import("/src/app/pages/documents_luna.vue")
  }
]